import PrivateRouteRedirection from "components/PrivateRouteRedirection";
import MainLayout from "layouts/MainLayout";
import ProductFormQuantityPage from "pages/privatePages/product/ProductFormQuantityPage";
import React from "react";
import { Route } from "react-router-dom";

const AccountingPage = React.lazy(
  () => import("pages/privatePages/accounting/AccountingPage")
);
const CategoryPage = React.lazy(
  () => import("pages/privatePages/category/CategoryPage")
);
const ChargesPage = React.lazy(
  () => import("pages/privatePages/charges/ChargePage")
);
const CompanyPage = React.lazy(
  () => import("pages/privatePages/company/CompanyPage")
);
const DashboardPage = React.lazy(
  () => import("pages/privatePages/dashboard/DashboardPage")
);
const DepotPage = React.lazy(
  () => import("pages/privatePages/depot/DepotPage")
);
const ProductPage = React.lazy(
  () => import("pages/privatePages/product/ProductPage")
);
const ReportsPage = React.lazy(
  () => import("pages/privatePages/reports/ReportsPage")
);
const UserPage = React.lazy(() => import("pages/privatePages/user/UserPage"));
const ProductFormPage = React.lazy(
  () => import("pages/privatePages/product/ProductFormPage")
);
const ProductDetailsPage = React.lazy(
  () => import("pages/privatePages/product/ProductDetailsPage")
);
const HistoryPage = React.lazy(
  () => import("pages/privatePages/history/HistroyPage")
);
const SalesPage = React.lazy(
  () => import("pages/privatePages/sales/SalesPage")
);

const privateRoutes = (
  <>
    <Route
      element={
        <PrivateRouteRedirection>
          <MainLayout />
        </PrivateRouteRedirection>
      }
    >
      <Route
        path="/dashboard"
        element={
          <PrivateRouteRedirection
            allowedRoles={["super_admin", "admin", "manager", "employee"]}
          >
            <DashboardPage />
          </PrivateRouteRedirection>
        }
      />
      <Route
        path="/products"
        element={
          <PrivateRouteRedirection
            allowedRoles={["admin", "manager", "employee"]}
          >
            <ProductPage />
          </PrivateRouteRedirection>
        }
      />

      <Route
        path="/products/new"
        element={
          <PrivateRouteRedirection allowedRoles={["admin", "manager"]}>
            <ProductFormPage />
          </PrivateRouteRedirection>
        }
      />

      <Route
        path="/products/:productId"
        element={
          <PrivateRouteRedirection allowedRoles={["admin", "manager"]}>
            <ProductFormPage />
          </PrivateRouteRedirection>
        }
      />
      <Route
        path="/products/update-quantity/:productId"
        element={
          <PrivateRouteRedirection allowedRoles={["admin", "manager"]}>
            <ProductFormQuantityPage />
          </PrivateRouteRedirection>
        }
      />

      <Route
        path="/products/details/:productId"
        element={
          <PrivateRouteRedirection
            allowedRoles={["admin", "manager", "employee"]}
          >
            <ProductDetailsPage />
          </PrivateRouteRedirection>
        }
      />

      <Route
        path="/categories"
        element={
          <PrivateRouteRedirection
            allowedRoles={["super_admin", "admin", "manager", "employee"]}
          >
            <CategoryPage />
          </PrivateRouteRedirection>
        }
      />
      <Route
        path="/depots"
        element={
          <PrivateRouteRedirection
            allowedRoles={["super_admin", "admin", "manager", "employee"]}
          >
            <DepotPage />
          </PrivateRouteRedirection>
        }
      />
      <Route
        path="/companies"
        element={
          <PrivateRouteRedirection allowedRoles={["super_admin"]}>
            <CompanyPage />
          </PrivateRouteRedirection>
        }
      />
      <Route
        path="/users"
        element={
          <PrivateRouteRedirection allowedRoles={["super_admin", "admin"]}>
            <UserPage />
          </PrivateRouteRedirection>
        }
      />

      <Route
        path="/history"
        element={
          <PrivateRouteRedirection allowedRoles={["admin"]}>
            <HistoryPage />
          </PrivateRouteRedirection>
        }
      />

      <Route
        path="/sales"
        element={
          <PrivateRouteRedirection allowedRoles={["admin"]}>
            <SalesPage />
          </PrivateRouteRedirection>
        }
      />
      <Route
        path="/accounting"
        element={
          <PrivateRouteRedirection allowedRoles={["admin", "manager"]}>
            <AccountingPage />
          </PrivateRouteRedirection>
        }
      />
      <Route
        path="/charges"
        element={
          <PrivateRouteRedirection allowedRoles={["admin", "manager"]}>
            <ChargesPage />
          </PrivateRouteRedirection>
        }
      />
      <Route
        path="/reports"
        element={
          <PrivateRouteRedirection
            allowedRoles={["admin", "manager", "employee"]}
          >
            <ReportsPage />
          </PrivateRouteRedirection>
        }
      />
    </Route>
  </>
);

export default privateRoutes;
